const BRUSH_URL = '/assets/lottie/brush.json';

let brushPromise: Promise<object | null> | null = null;

export const loadBrushLottie = () => {
	if (!brushPromise)
		brushPromise = (async () => {
			try {
				const response = await fetch(BRUSH_URL);
				if (!response.ok) throw new Error(response.statusText);
				return (await response.json()) as object;
			} catch {
				return null;
			}
		})();

	return brushPromise;
};
